import { Icon } from "@mui/material";

import { MessageKey } from "lang";
import { DEFAULT, EARNINGS, FORECAST, INVERTER, NOTIFICATIONS, PRICES, RECORDS, RELAY, STATISTICS } from "routes/consts";

type ListItem = {
  value: string;
  label: MessageKey;
  icon: JSX.Element;
  requiresRelay?: boolean;
  requiresMarketPrices?: boolean;
  requiresInverter?: boolean;
};

export const mainListItems: ListItem[] = [
  { value: DEFAULT, label: "pageTitle.dashboard", icon: <Icon>home</Icon> },
  { value: RECORDS, label: "pageTitle.records", icon: <Icon>bar_chart</Icon> },
  { value: FORECAST, label: "pageTitle.forecast", icon: <Icon>insights</Icon> },
];

export const secondaryListItems: ListItem[] = [
  {
    value: STATISTICS,
    label: "pageTitle.statistics",
    icon: <Icon baseClassName="material-icons-outlined">analytics</Icon>,
  },
  {
    value: PRICES,
    label: "pageTitle.prices",
    icon: <Icon baseClassName="material-icons-outlined">electric_bolt</Icon>,
    requiresMarketPrices: true,
  },
  {
    value: EARNINGS,
    label: "pageTitle.earnings",
    icon: <Icon baseClassName="material-icons-outlined">payments</Icon>,
    requiresMarketPrices: true,
  },
  {
    value: NOTIFICATIONS,
    label: "pageTitle.notifications",
    icon: <Icon>notifications</Icon>,
  },
  {
    value: RELAY,
    label: "pageTitle.relay",
    icon: <Icon>power_settings_new</Icon>,
    requiresRelay: true,
  },
  {
    value: INVERTER,
    label: "pageTitle.inverter",
    icon: <Icon baseClassName="material-icons-outlined">solar_power</Icon>,
    requiresInverter: true,
  },
];

export const bottomListItems: ListItem[] = [
  { value: DEFAULT, label: "pageTitle.myAccount", icon: <Icon>person</Icon> },
];
